// initial state
const state = () => ({
  // 現在入力されている課題の情報
  selectedTask : {},
  // LocalStorage上にあるトライした課題の情報
  storageData : [],
  // トースト表示フラグ※z-indexの関係でグローバル管理したい
  isShowToast : false
})

// getters
const getters = {
  getTask: (state: { selectedTask: any }) => {
    return state.selectedTask
  },
  getStorageData: (state: { storageData: any }) => {
    return state.storageData
  },
  getIsShowToast: (state: { isShowToast: boolean }) => {
    return state.isShowToast
  }
}

// mutations
const mutations = {
  // 入力中のデータをvuexに保管
  setTask (state: { selectedTask: any }, inputData: any) {
    state.selectedTask = inputData
  },
  // トースト表示フラグ上げ下げ
  setIsShowToast (state: {isShowToast: boolean}) {
    state.isShowToast = true
    setTimeout(() => {
      state.isShowToast = false
    }, 1000);
  },
  // 入力データをlocalstorageに追加してvuex更新
  updateStorageData (state: { storageData: any }, inputData: any) {
    localStorage.setItem("results", JSON.stringify(inputData))
  },
  // vuexをlocalstorage側に同期sinc
  syncStorageData (state: { storageData: any }) {
    state.storageData = localStorage.getItem("results")
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}